module.exports = __webpack_public_path__ + "static/img/中秋.4d2021a2.jpg";